/* eslint-disable no-console */
export class Logger {
  LEVEL_DEBUG: string = 'debug';

  LEVEL_INFO: string = 'info';

  LEVEL_WARNING: string = 'warning';

  LEVEL_ERROR: string = 'error';

  /**
   * A window.console wrapper
   */
  printLog(message: string, level: string | null = null): void {
    switch (level) {
      case this.LEVEL_DEBUG:
        console.debug(message);
        break;
      case this.LEVEL_INFO:
        console.info(message);
        break;
      case this.LEVEL_WARNING:
        console.warn(message);
        break;
      case this.LEVEL_ERROR:
        console.error(message);
        break;
      default:
        console.log(message);
    }
  }

  /**
   * window.console messages for development and QA environments
   */
  log(message: string, level: string | null = null): void {
    this.printLog(message, level);
  }

  error(message: string): void {
    this.printLog(message, this.LEVEL_ERROR);
  }

  errors(...messages: unknown[]): void {
    console.error(...messages);
  }

  info(message: string): void {
    this.printLog(message, this.LEVEL_INFO);
  }

  warning(message: string): void {
    this.printLog(message, this.LEVEL_WARNING);
  }

  table(data: unknown, properties?: string[]): void {
    console.table(data, properties);
  }
}

export default new Logger();
